import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg} from 'utils';

export default {
    methods: {
        getList() {
            this.lists = [];
            this.loading = true; //拼命加载中显示
            var param = { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize };
            // if(this.query.workTime==''){
            //     this.query.workTime='-1' 
            // }
            var Params=Object.assign({},param,util.getFormSearchParams(this.query))
            $http.get("api/Employee/GetEmployeeByPage", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false; //拼命加载中显示
                    for (var i = 0; i < Data.length; i++) {
                        if (Data[i].canlogin == "1") {
                            Data[i].canlogin = "是";
                        } else {
                            Data[i].canlogin = "否";
                        }
                        if (Data[i].EntryDate != "") {
                            Data[i].EntryDate = new Date(Data[i].EntryDate).toLocaleDateString();
                        }
                    }
                    this.lists = Data;
                })
            })
        },
        getEmployee() {
            var Params = { Sid: this.sysSid, Session: this.sysSession };
            $http.get("api/Department/GetDepartmentList", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.TreeDataList = Data;
                })
            })
        },
        GetEmployeeById(item) {
            jToast.loading();
            var Params = { Sid: this.sysSid, Session: this.sysSession, Id: item.ID };
            $http.get("api/Employee/GetEmployeeById", Params).then(res => {
                jToast.close();
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    Data.WorkAddress = parseInt(Data.WorkAddress);
                    this.ActionEmployee.name = Data.LineManagerName;
                    this.ActionEmployee.ID = Data.LineManager;
                    this.ActionPartment.D_Name = Data.d_Name;
                    this.ActionPartment.Id = Data.d_id;
                    Data.Subjection = (Data.Subjection).length == 0 ? [] : (Data.Subjection).split(",");
                    for (var i = 0; i < Data.Subjection.length; i++) {
                        Data.Subjection[i] = parseInt(Data.Subjection[i]);
                    }
                    this.Form = Data;
                    this.checkedListBtnName = Data.ModuleRoleList[2].ListBtnName;
                    this.checkedProvinceList = this.Form.ModuleRoleList[0].ProvRoles;
                    this.setProvAreaTxt(this.checkedProvinceList);
                    this.AddEmployeeVisible = true;
                    if(this.Form.Status=='离职'){
                        this.isDisable=false
                    }else{
                        this.isDisable=true
                    }
                    if(this.Form.LaborRelations.length==0){
                        this.Form.LaborRelations=[{}]
                    }
                });
            });
        },
        getCrmfig(num) {
            /*14代表获取工作地列表   15 代表获取隶属项目的列表*/
            var Params = { Sid: this.sysSid, Session: this.sysSession, ParentId: num };
            $http.get("api/Common/GetCrmConfig", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    if (num == 14) {
                        this.WorkAddress = Data;
                    }
                });
            });
        },
        getManager(item, info) {
            if (info == "search") {
                var Params = { Sid: this.sysSid, Session: this.sysSession, userName: item }
            } else {
                var Params = { Sid: this.sysSid, Session: this.sysSession, deptId: item.Id };
            }

            $http.get("api/Employee/GetEmployeeByPage", Params).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.ManageData = Data;
            });
        },
        EmployeeAdd(Params) {
            jToast.loading();
            $http.post("api/Employee/EmployeeAddEx", Params).then(res => {
                jToast.close();
                util.doResult(this, res, () => {
                    this.AddEmployeeVisible = false;
                    this.getList();
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.$refs['ruleForm'].resetFields();
                })
            });
        },
        EmployeeUpdate(Params) {
            jToast.loading();
            $http.post("api/Employee/EmployeeUpdateEx", Params).then(res => {
                jToast.close();
                util.doResult(this, res, () => {
                    this.AddEmployeeVisible = false;
                    this.getList();
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                    this.$refs['ruleForm'].resetFields();
                });
            });
        },
        EmployeeDel(Params) {
            jToast.loading();
            $http.post("api/Employee/EmployeeDel", Params).then(res => {
                jToast.close();
                util.doResult(this, res, () => {
                    this.getList();
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success'
                    });
                })
            })
        },
        //获取直线经理
        GetLineManage(deptId) {
            var Params = { Sid: this.sysSid, Session: this.sysSession,deptId:deptId};
            jToast.loading();
            $http.get("api/Employee/GetLineManage", Params).then(res => {
                jToast.close();
                util.doResult(this, res, () => {
                    let data=res.data.Data
                    this.ActionEmployee.name = data.Name;
                    this.ActionEmployee.ID = data.Id;
                })
            })
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/personManage/EmployeeManage/services.js